export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/edu.9ef54ff6.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};